export const getDataSetSummary = (
    data: Array<Record<string, unknown>>,
    key: string
) =>
    data.reduce((acc, item) => {
        const value = item[key]
        if (value && typeof value === 'number') {
            return acc + value
        }
        return acc
    }, 0)
